import { Link } from 'react-router-dom';
import { Instagram, Facebook, MapPin, Phone, Mail, Clock } from 'lucide-react';
import { SITE } from '../data/content';
import { SerapeBand } from './Serape';

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-brand-ink text-brand-cream">
      <SerapeBand />
      <div className="mx-auto max-w-7xl px-6 md:px-12 pt-20 pb-10">
        <div className="grid gap-12 md:grid-cols-4">
          <div className="md:col-span-1">
            <img src="/cantaritos-logo.png" alt="Cantaritos Dallas" className="h-16 w-auto" />
            <p className="text-brand-cream/60 text-sm mt-5 leading-relaxed">
              Una mezcalería que celebra los cantaritos de México — cócteles en jarrito de barro, destilados de agave y música mexicana en vivo.
            </p>
          </div>

          <div>
            <p className="text-brand-gold uppercase text-xs tracking-[0.25em] mb-4">Explorar</p>
            <ul className="space-y-2 text-sm text-brand-cream/70">
              <li><Link to="/menu" className="hover:text-brand-gold transition-colors">Menú</Link></li>
              <li><Link to="/live-music" className="hover:text-brand-gold transition-colors">Música en Vivo</Link></li>
              <li><Link to="/private-events" className="hover:text-brand-gold transition-colors">Eventos Privados</Link></li>
              <li><Link to="/contact" className="hover:text-brand-gold transition-colors">Contáctanos</Link></li>
            </ul>
          </div>

          <div>
            <p className="text-brand-gold uppercase text-xs tracking-[0.25em] mb-4">Visitar</p>
            <ul className="space-y-3 text-sm text-brand-cream/70">
              <li className="flex gap-3"><MapPin size={16} className="text-brand-terracotta shrink-0 mt-0.5" />{SITE.address}</li>
              <li className="flex gap-3"><Phone size={16} className="text-brand-terracotta shrink-0 mt-0.5" /><a href={`tel:${SITE.phone}`} className="hover:text-brand-gold">{SITE.phone}</a></li>
              <li className="flex gap-3"><Mail size={16} className="text-brand-terracotta shrink-0 mt-0.5" /><a href={`mailto:${SITE.email}`} className="hover:text-brand-gold">{SITE.email}</a></li>
            </ul>
          </div>

          <div>
            <p className="text-brand-gold uppercase text-xs tracking-[0.25em] mb-4">Horario</p>
            <ul className="space-y-2 text-sm text-brand-cream/70">
              {SITE.hours.map((h) => (
                <li key={h.day} className="flex justify-between gap-4">
                  <span className="flex items-center gap-2"><Clock size={14} className="text-brand-terracotta" />{h.day}</span>
                  <span className="text-brand-cream/50">{h.time}</span>
                </li>
              ))}
            </ul>
            <div className="flex gap-3 mt-6">
              <a href={SITE.socials.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="p-2 border border-brand-line hover:border-brand-gold hover:text-brand-gold transition-colors"><Instagram size={18} /></a>
              <a href={SITE.socials.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="p-2 border border-brand-line hover:border-brand-gold hover:text-brand-gold transition-colors"><Facebook size={18} /></a>
            </div>
          </div>
        </div>

        <div className="mt-16 border-t border-brand-line pt-6 flex flex-col sm:flex-row justify-between gap-3 text-xs text-brand-cream/40">
          <p>© {new Date().getFullYear()} Cantaritos Dallas. Todos los derechos reservados.</p>
          <p>Salud · Cocina de México · Dallas, TX</p>
        </div>
      </div>

      <div className="overflow-hidden select-none pointer-events-none">
        <p className="font-display font-black text-[18vw] leading-[0.8] tracking-tighter text-brand-terracotta/10 whitespace-nowrap text-center pb-4">
          CANTARITOS
        </p>
      </div>
    </footer>
  );
};
